import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import "./TemplateOne.scss";
const TemplateOne = (props) => {
  const [letterData, setLetterData] = useState("");
  const editorData = useSelector((state) => state.editorData);

  useEffect(() => {
    if (props && props.preview) {
      setLetterData(props && props.data);
    } else {
      setLetterData(editorData);
    }
  }, [editorData, props]);

  return (
    <>
      {letterData && letterData.from && letterData.from != "" && (
        <div
          className="templateOne"
          style={
            props && props.preview
              ? { pointerEvents: "none" }
              : { pointerEvents: "none" }
          }
        >
          <div className="row m-0">
            <div className="col-md-1 cover_border">
              <div className="cover_border_div"></div>
            </div>
            <div className="col-md-10 cover_content_div">
              <div>
                <div className="">
                  {letterData &&
                    letterData.from &&
                    letterData.from.data &&
                    letterData.from.data.map((res, index) => (
                      <>
                        <p className="cover_name">{res.full_name}</p>
                        <p className="cover_job">{res.job_title}</p>
                        <p>{res.email}</p>
                        <p>{res.phone}</p>
                        <p>{res.address}</p>
                      </>
                    ))}
                </div>
              </div>

              <div className="mt-4">
                {letterData &&
                  letterData.to &&
                  letterData.to.data &&
                  letterData.to.data.map((res, index) => (
                    <>
                      <p>{res.company}</p>
                      <p>{res.department}</p>
                      <p>{res.address}</p>
                      <p>{res.city}</p>
                      <p>{res.country}</p>
                      <p>{res.postal_code}</p>
                    </>
                  ))}
              </div>

              <div className="mt-3">
                {letterData &&
                  letterData.content &&
                  letterData.content.data &&
                  letterData.content.data.map((res, index) => (
                    <>
                      <div className="row">
                        {/* <div className="col-md-12 mb-2">
												<p className="">Sub: {res.subject}</p>

											</div> */}
                        {/* <div className="col-md-12">
												<p className="">Date: {res && res.date instanceof Date ? res.date.toLocaleString('en-us', { month: 'short' }) + "/" + res.date.getFullYear() : new Date(res.date).toLocaleString('en-us', { month: 'short' }) + "/" + new Date(res.date).getFullYear()}</p>

											</div> */}
                      </div>

                      <div
                        className=" mt-3"
                        dangerouslySetInnerHTML={{ __html: res.description }}
                      ></div>
                    </>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TemplateOne;
